export enum DatabaseType {
    Legacy = 'legacy',
    Tablesdb = 'tablesdb',
}